import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledAppNotification = styled.div<{
  $read: boolean;
  $expanded: boolean;
}>`
  cursor: ${({ $read }) => (!$read ? "pointer" : "auto")};
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  width: 100%;
  box-sizing: border-box;
  gap: 15px;
  border-radius: ${theme.variables.border_radius_2};
  background-color: ${({ $read }) =>
    $read ? "transparent" : theme.colors.purple_5};
  border-radius: ${theme.variables.border_radius_2};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out background-color 0.3s ease;
  will-change: max-height;
`;

export const StyledAppNotificationIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  background-color: ${theme.colors.purple};
  border-radius: 100px;
  & svg path {
    stroke: ${theme.colors.white};
  }
`;

export const StyledAppNotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  & .notification-content-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    gap: 16px;
  }

  & .notification-content-description {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  & .notification-content-header-badge {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    gap: 8px;
  }
`;
